"use client";
import {
  GroupLabelContext
} from "./3X3MDQGM.js";
import {
  createComponent,
  createElement,
  createHook
} from "./LFJDOMBA.js";
import {
  useId,
  useSafeLayoutEffect
} from "./6WEF4WY5.js";
import {
  __spreadValues
} from "./2SMRF6AD.js";

// src/group/group-label.ts
import { useContext } from "react";
var useGroupLabel = createHook((props) => {
  const setLabelId = useContext(GroupLabelContext);
  const id = useId(props.id);
  useSafeLayoutEffect(() => {
    setLabelId == null ? void 0 : setLabelId(id);
    return () => setLabelId == null ? void 0 : setLabelId(void 0);
  }, [setLabelId, id]);
  props = __spreadValues({
    id,
    "aria-hidden": true
  }, props);
  return props;
});
var GroupLabel = createComponent((props) => {
  const htmlProps = useGroupLabel(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  GroupLabel.displayName = "GroupLabel";
}

export {
  useGroupLabel,
  GroupLabel
};
